<template>
  <main class="quiz46-screen" :data-status="status">
    <section class="result-card" aria-live="polite">
      <header class="brand-row">
        <span class="brand">UFA EASY888</span>
        <span class="topic">ระบบแนะนำเพื่อน</span>
      </header>

      <div class="result-copy">
        <p class="eyebrow">{{ content.eyebrow }}</p>
        <h1>{{ content.title }}</h1>
        <p class="description">{{ content.description }}</p>
      </div>

      <section v-if="status !== 'loading'" class="calculation">
        <div class="calc-line">
          <span>ยอดฝาก</span>
          <strong>1,000 บาท</strong>
        </div>
        <div class="calc-line deduction">
          <span>หักยอดถอน</span>
          <strong>− 300 บาท</strong>
        </div>
        <div class="calc-total">
          <span>ยอดสุทธิ 700 × 5%</span>
          <strong>35 บาท</strong>
        </div>
      </section>

      <div
        v-if="status === 'loading'"
        class="progress"
        aria-label="กำลังตรวจคำตอบ"
      >
        <span></span>
      </div>

      <div v-if="status === 'correct'" class="reward-panel">
        <span>รางวัลที่ได้รับ</span>
        <strong>+5 COINS</strong>
      </div>

      <footer>
        {{ footerText }}
      </footer>
    </section>
  </main>
</template>

<script>
export default {
  name: "Quiz46Status",
  props: {
    status: {
      type: String,
      default: "loading"
    }
  },
  computed: {
    content() {
      const states = {
        loading: {
          eyebrow: "กำลังตรวจคำตอบ",
          title: "รอสักครู่นะคะ",
          description: "ระบบกำลังบันทึกคำตอบและตรวจสิทธิ์รับรางวัลของคุณ"
        },
        correct: {
          eyebrow: "คำตอบถูกต้อง",
          title: "คิดยอดสุทธิได้เป๊ะ",
          description: "ยอดฝาก 1,000 บาท หักถอน 300 บาท เหลือยอดสุทธิ 700 บาท"
        },
        incorrect: {
          eyebrow: "เกือบถูกแล้ว",
          title: "คำตอบคือ 35 บาท",
          description: "โบนัสแนะนำคิด 5% จากยอดสุทธิหลังหักยอดถอน"
        },
        already: {
          eyebrow: "บันทึกคำตอบแล้ว",
          title: "ข้อนี้ตอบไปแล้วนะคะ",
          description: "หนึ่งบัญชีตอบได้หนึ่งครั้ง รอร่วมสนุกกับคำถามใหม่ได้เลย"
        },
        error: {
          eyebrow: "เชื่อมต่อไม่สำเร็จ",
          title: "ยังบันทึกคำตอบไม่ได้",
          description: "กรุณาปิดหน้านี้แล้วแตะคำตอบจากแชต LINE อีกครั้ง"
        }
      };

      return states[this.status] || states.loading;
    },
    footerText() {
      if (this.status === "loading") {
        return "อย่าเพิ่งปิดหน้านี้ ระบบจะส่งผลกลับไปในแชต LINE อัตโนมัติ";
      }

      if (this.status === "error") {
        return "คำตอบจะยังไม่นับจนกว่าระบบจะบันทึกสำเร็จ";
      }

      return "ระบบกำลังส่งผลกลับไปในแชต LINE และจะปิดหน้านี้ให้อัตโนมัติ";
    }
  }
};
</script>

<style scoped>
.quiz46-screen {
  --night: #181534;
  --night-deep: #080817;
  --violet: #5b4ed0;
  --amber: #f6d365;
  --paper: #fff8ec;
  --ink: #24213f;
  --muted: #6e6c80;
  min-height: 100vh;
  padding: 24px 18px;
  display: grid;
  place-items: center;
  color: var(--ink);
  font-family: "Thonburi", "Leelawadee UI", "Noto Sans Thai", sans-serif;
  background: radial-gradient(
      circle at 9% 3%,
      rgba(246, 211, 101, 0.2),
      transparent 29%
    ),
    radial-gradient(
      circle at 92% 88%,
      rgba(255, 122, 104, 0.13),
      transparent 27%
    ),
    linear-gradient(145deg, #29235f 0%, var(--night-deep) 72%);
}

.quiz46-screen * {
  font-family: inherit;
}

.result-card {
  width: min(100%, 420px);
  overflow: hidden;
  border: 1px solid rgba(246, 211, 101, 0.34);
  border-radius: 24px;
  background: var(--paper);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.36);
}

.brand-row {
  min-height: 68px;
  padding: 20px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  color: white;
  background: var(--night);
}

.brand,
.topic {
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.08em;
}

.brand {
  color: var(--amber);
}

.topic {
  letter-spacing: 0;
  opacity: 0.72;
}

.result-copy {
  padding: 30px 24px 22px;
}

.eyebrow {
  margin: 0 0 9px;
  color: var(--violet);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.05em;
}

h1 {
  margin: 0;
  color: var(--ink);
  font-size: clamp(30px, 9vw, 40px);
  font-weight: 900;
  line-height: 1.12;
  letter-spacing: -0.035em;
}

.description {
  margin: 14px 0 0;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.7;
}

.calculation {
  margin: 0 24px 20px;
  padding: 17px;
  border: 1px solid #d8d2c5;
  border-radius: 14px;
  background: #eee9df;
}

.calc-line,
.calc-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  font-size: 13px;
}

.calc-line {
  padding: 7px 0;
  color: var(--muted);
}

.calc-line strong {
  color: var(--ink);
}

.deduction {
  border-bottom: 1px solid #d8d2c5;
}

.calc-total {
  padding-top: 14px;
  color: var(--violet);
  font-weight: 800;
}

.calc-total strong {
  font-size: 24px;
  font-weight: 950;
}

.reward-panel {
  margin: 0 24px 22px;
  padding: 16px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: 14px;
  color: var(--night);
  background: var(--amber);
}

.reward-panel span {
  font-size: 12px;
  font-weight: 800;
}

.reward-panel strong {
  font-size: 22px;
  font-weight: 950;
}

.progress {
  height: 5px;
  margin: 10px 24px 31px;
  overflow: hidden;
  border-radius: 99px;
  background: #d8d2c5;
}

.progress span {
  display: block;
  width: 44%;
  height: 100%;
  border-radius: inherit;
  background: var(--violet);
  animation: progress 1.2s ease-in-out infinite alternate;
}

footer {
  padding: 17px 24px 21px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 11px;
  line-height: 1.55;
  text-align: center;
  background: var(--night);
}

[data-status="incorrect"] .eyebrow,
[data-status="already"] .eyebrow,
[data-status="error"] .eyebrow {
  color: #a34b3f;
}

@keyframes progress {
  from {
    transform: translateX(-8%);
  }
  to {
    transform: translateX(145%);
  }
}

@media (max-width: 360px) {
  .quiz46-screen {
    padding: 14px;
  }
  .brand-row {
    padding-inline: 18px;
  }
  .result-copy {
    padding-inline: 20px;
  }
  .calculation,
  .reward-panel,
  .progress {
    margin-inline: 20px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .progress span {
    animation: none;
    width: 70%;
  }
}
</style>
